const intlLangNamesInstance = new Intl.DisplayNames(['en'], { type: 'language' })

export const getLanguageFromCode = code => intlLangNamesInstance.of(code)
